import { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../contexts/AuthContext';

// Respostas rapidas server-side (seguem o LOGIN, nao o aparelho). Cache em memoria
// + listeners pra todas as telas (picker no chat + CRUD em Configuracoes) ficarem
// em sincronia ao vivo.
let cache = null;
const listeners = new Set();
const emit = () => listeners.forEach((l) => l());

export async function carregarRespostas(force = false) {
  if (cache && !force) return cache;
  try {
    const res = await axios.get(`${API}/respostas-rapidas`);
    cache = res.data?.data || [];
  } catch (e) {
    cache = cache || [];
  }
  emit();
  return cache;
}

export async function criarResposta(atalho, texto) {
  await axios.post(`${API}/respostas-rapidas`, { atalho, texto });
  await carregarRespostas(true);
}

export async function atualizarResposta(id, atalho, texto) {
  await axios.put(`${API}/respostas-rapidas/${id}`, { atalho, texto });
  await carregarRespostas(true);
}

export async function excluirResposta(id) {
  await axios.delete(`${API}/respostas-rapidas/${id}`);
  await carregarRespostas(true);
}

// ---------------------------------------------------------------------------
// Variáveis das mensagens prontas. Ficam AQUI (e não espalhadas nas telas) pra
// a lista de opções, a explicação e o resultado serem sempre os mesmos.
// ---------------------------------------------------------------------------
export const VARIAVEIS_RESPOSTA = [
  {
    chave: '{nome}',
    rotulo: 'Nome do cliente',
    ajuda: 'Só o primeiro nome. "Pedro da Marcenaria" vira "Pedro".',
    resolver: (ctx) => primeiroNome(ctx.nomeCliente),
  },
  {
    chave: '{nome_completo}',
    rotulo: 'Nome completo',
    ajuda: 'O nome inteiro, do jeito que está salvo na agenda.',
    resolver: (ctx) => nomeLimpo(ctx.nomeCliente),
  },
  {
    chave: '{atendente}',
    rotulo: 'Seu nome',
    ajuda: 'O nome de quem está enviando a mensagem.',
    resolver: (ctx) => bonito(ctx.atendente),
  },
];

// "553299168902" não é nome: vira vazio, senão sai "Olá 553299168902".
function nomeLimpo(valor) {
  const t = String(valor || '').trim();
  if (!t || /^[+\d\s()-]+$/.test(t)) return '';
  return t;
}
function primeiroNome(valor) {
  return nomeLimpo(valor).split(/\s+/)[0] || '';
}
// "CLEITON.ARAUJO" -> "Cleiton Araujo"
function bonito(login) {
  const t = String(login || '').trim();
  if (!t) return '';
  return t.replace(/\./g, ' ').toLowerCase().split(/\s+/).filter(Boolean)
    .map((p) => p.charAt(0).toUpperCase() + p.slice(1)).join(' ');
}

// Troca as variáveis pelos valores reais. Variável sem valor é REMOVIDA (não
// mandamos "Olá {nome}" pro cliente), e a pontuação órfã é limpa.
export function resolverVariaveis(texto, ctx = {}) {
  let out = String(texto || '');
  VARIAVEIS_RESPOSTA.forEach((v) => {
    const nomeVar = v.chave.slice(1, -1);
    const re = new RegExp(`\\{\\s*${nomeVar}\\s*\\}`, 'gi');
    out = out.replace(re, v.resolver(ctx) || '');
  });
  // compat: {primeiro_nome} era o nome antigo de {nome}
  out = out.replace(/\{\s*primeiro_nome\s*\}/gi, primeiroNome(ctx.nomeCliente));
  return out.replace(/[ \t]{2,}/g, ' ').replace(/\s+([,.!?])/g, '$1').trim();
}

export function useRespostasRapidas() {
  const [lista, setLista] = useState(cache || []);
  useEffect(() => {
    const l = () => setLista(cache || []);
    listeners.add(l);
    if (cache === null) carregarRespostas().catch(() => {});
    else setLista(cache);
    return () => { listeners.delete(l); };
  }, []);
  return lista;
}
